<template>
  <v-layout 
    align-center 
    justify-center>
    <v-flex xs12>
      <v-card
        max-width="450"
        style="margin: auto;"
        class="text-xs-center roundedcard py-3 px-3"
        color="rgba(255, 255, 255, 0.1)">
        <v-card-text class="py-1">
          <v-img
            class="wevent_icon"
            contain
            :src="require('@/assets/TextWeVent_thumbnail_beta.svg')"></v-img>
            <!-- :src="require('@/assets/Wevent_Logo_only_text_black.svg')"></v-img> -->
            
            <!-- <p class="display-1 text-xs-center white--text">Login</p> -->
        </v-card-text>
        
        <v-card-actions>
          <v-layout
            row
            wrap>
            <v-flex
              v-if="isMobile && !displayNews" 
              xs12
              class="text-xs-center my-2 px-2">
              <v-btn
                round
                class="grey--text text--lighten-4 font-weight-bold"
                style="z-index: 5"
                color="rgba(255,255,255,0.2)"
                dark
                block
                depressed
                @click.stop="setDisplayNews">
                <v-icon
                  left>
                  fas fa-rss
                </v-icon>
                Zu den News
              </v-btn>
            </v-flex>
            <v-flex
              xs12
              class="text-xs-center my-2 px-2">
              <v-btn
                round
                block
                class="grey--text text--lighten-4 font-weight-bold"
                style="z-index: 5"
                color="rgba(255,255,255,0.2)"
                depressed
                dark
                @click.stop="whatIsWeVent = true">
                <v-icon class="mr-1">
                  fas fa-person-sign
                </v-icon>
                Was ist WeVent
                <v-icon
                  class="ml-1"
                  small>
                  fas fa-question
                </v-icon>
              </v-btn>
            </v-flex>
            <v-dialog 
              v-model="whatIsWeVent" 
              scrollable
              width="600px">
              <app-what-is-wevent @close-dialog="whatIsWeVent = false"></app-what-is-wevent>
            </v-dialog>
          </v-layout>
        </v-card-actions>

        <!-- <v-card-text> -->
        <form @submit.prevent="onLogin">
          <v-text-field 
            v-model="email"
            autocomplete="username"
            :style="$v.email.$error ? '' : '-webkit-text-fill-color: #fff;'"
            label="Email"
            name="email"
            type="email"
            dark
            outline
            :error-messages="emailErrors"
            @change="$v.email.$touch()"
            @blur="$v.email.$touch()">
          </v-text-field>

          <v-text-field 
            v-model="password"
            autocomplete="current-password"
            :style="$v.password.$error ? '' : '-webkit-text-fill-color: #fff;'"
            name="password"
            type="password"
            dark
            outline
            :error-messages="passwordErrors"
            label="Password"
            @change="$v.password.$touch()"
            @blur="$v.password.$touch()"></v-text-field>

          <!-- <div
            v-if="pleaseVerifyMail"
            class="white--text text-xs-center animated tada delay-0.3s ease-in-out">
            Email muss verifiziert sein!
          </div> -->

         
          <v-btn 
            type="submit"
            color="rgba(255, 255, 255, 0.8)"
            class="mt-2"
            style="width: 80%"
            :loading="loading">
            Login
          </v-btn>
          <v-snackbar
            v-model="snackbar"
            color="blue darken-3"
            multi-line
            :timeout="6000">
            Email muss verifiziert sein!
            <v-btn
              dark
              flat
              @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>

         
          <!-- <v-btn 
            type="submit"
            color="rgba(255, 255, 255, 0.8)"
            class="mt-2"
            style="width: 80%"
            v-on="on"
            :loading="loading">
            Login
          </v-btn> -->
        </form>


       
        <v-btn
          small
          class="text-none"
          color="white"
          flat
          round
          @click="pwforgot = true">
          Passwort vergessen?
        </v-btn>

        <v-dialog 
          v-model="pwforgot" 
          scrollable
          max-width="300">
          <v-card>
            <v-card-title>
              <span 
                class="secondary--text">
                Passwort vergessen?
              </span>
            </v-card-title>
    
            <v-card-text class="text-xs-center">
              <form @submit.prevent="passwordReset">
                <v-text-field 
                  v-model="emailreset"
                  label="Email"
                  name="email"
                  type="email"
                  outline
                  :error-messages="emailResetErrors"
                  @change="$v.emailreset.$touch()"
                  @blur="$v.emailreset.$touch()"></v-text-field>

                <v-btn 
                  type="submit"
                  color="primary"
                  block
                  dark 
                  
                  @click.stop="">
                  Reset Password
                </v-btn>
              </form>
            </v-card-text>
            <v-card-actions>
              <!-- <v-spacer></v-spacer> -->
              <v-btn 
                color="primary" 
                small
                flat
                block
                @click="pwforgot = false">
                Abbrechen
              </v-btn>
            </v-card-actions>
          </v-card> 
        </v-dialog> 

        <!-- </v-card-text> -->
        <!-- <v-layout 
          align-center 
          justify-center
          class="text-xs-center">
          <v-flex xs12>
            <v-btn 
              class="mt-4"
              
              outline
              dark 
              @click.prevent="clickCreateAccount">
              Create Account
            </v-btn>
          </v-flex>
        </v-layout> -->
      </v-card>

      <v-layout 
        align-center 
        justify-center
        class="text-xs-center">
        <v-flex
          xs12
          class="text-xs-center mt-3">
          <div class="mt-1 white--text text-xs-center">
            Noch nicht angemeldet?
          </div>
          <v-btn
            round
            style="z-index: 5"
            color="rgba(255,255,255,0.3)"
            dark
            @click.prevent="clickCreateAccount">
            <v-icon
              left>
              fas fa-user-circle
            </v-icon>
            Create Account
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>



<script>
import WhatIsWevent from '@/components/global_comps/WhatIsWevent.vue'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'


export default {
  components: {
    // eslint-disable-next-line
    "app-what-is-wevent": WhatIsWevent
  },
  data () {
    return {
      email: '',
      password: '',

      pwforgot: false,
      emailreset: '',

      whatIsWeVent: false,
    }
  },
  validations: {
    email: {
      required,
      email
    },
    emailreset: {
      required,
      email
    },
    password: {
      required
    }
  },
  computed: {
    ...mapState({
      displayNews: state => state.displayNews,
      pleaseVerifyMail: state => state.user.pleaseVerifyMail,
      isMobile: state => state.isMobile,
      login: state => state.navigation.login,
      getBrand: state => require('@/assets/' + state.brand),

    }), 
    snackbar: {
      get() {
        return this.pleaseVerifyMail
      },
      set(value) {
     
        this.setPleaseVerifyMail(false)
      }
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.required && errors.push('Email is required.')
      !this.$v.email.email && errors.push('Invalid Email.')
      return errors
    },
    emailResetErrors() {
      const errors = []
      if (!this.$v.emailreset.$dirty) return errors
      !this.$v.emailreset.required && errors.push('Email is required.')
      !this.$v.emailreset.email && errors.push('Invalid Email.')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required.')
      return errors
    },
    ...mapGetters({
      user: 'user',
      error: 'error',
      // tokenName: 'tokenName',
      loading: 'loading'
    }),

    formIsValid() {
      return (
        !this.$v.email.$invalid &&
        !this.$v.password.$invalid
      )
    },

  },
  // watch: {
  //   user (value) {
  //     if (value !== null && value !== undefined) {
  //       console.log('WatchUserFrom_Login.vue')
  //       this.$router.push('/timeline')
  //     }
  //   }
  // },
  methods: {
    ...mapMutations([
      'setLogin',
      'setDisplayNews',
      'setPleaseVerifyMail'

    ]),
    ...mapActions([
      'sendPasswordResetMail'
    ]),

    clickCreateAccount() {
       
      this.setLogin(false)
      setTimeout(() => {
        this.$vuetify.goTo(0, {
          duration: 100,
          offset: 0,
          easing: 'easeInOutQuint'
        })
      }, 33)
    },

    onLogin () {
      setTimeout(() => {
        this.$vuetify.goTo(0, {
          duration: 100,
          offset: 0,
          easing: 'easeInOutQuint'
        })
      }, 33)
      if (!this.formIsValid) {
        this.$v.$touch()
      } else {
        this.$store.dispatch('loginUser', { email: this.email, password: this.password })
      }
    },

    passwordReset () {
      if (this.$v.emailreset.$invalid) {
        this.$v.emailreset.$touch()
      } else {
        
        this.sendPasswordResetMail({ email: this.emailreset })
        this.pwforgot = false
        this.emailreset = ''
      }
    },

  },
}
</script>

<style scoped>
 .wevent_icon {
  margin-top: 12px;

  height: 60px !important;
  width: auto;
  -webkit-filter: invert(1) opacity(0.8);
  filter: invert(1) opacity(0.8);

  /* filter: invert(0.6) sepia(0.8) saturate(5) hue-rotate(330deg); */
}

</style>
